import React, { Component } from 'react';
import { Container } from 'bloomer/lib/layout/Container';
import { Box } from 'bloomer/lib/elements/Box';
import { RouteComponentProps } from '@reach/router';
import Animal from '../Entities/Animal';
import api from '../util/api';
import LoadingSpinner from '../elements/LoadingSpinner';
import Conditional from '../components/Conditional';
import AnimalEditForm from '../components/AnimalEditForm';
import { popupErrorFromServer } from '../util/helperFunctions';

interface Params {
  aNumber: string;
}

interface PropTypes extends RouteComponentProps<Params> {}
interface StateTypes {
  animal: Animal;
  specialNeeds?: SpecialNeed[];
  isLoading: boolean;
}
class CreateAnimal extends Component<PropTypes, StateTypes> {
  state: StateTypes = {
    animal: Animal.blank(),
    specialNeeds: undefined,
    isLoading: true,
  };

  fetchSpecialNeeds = async (): Promise<SpecialNeed[]> => {
    this.setState({
      isLoading: true,
    });

    const specialNeeds = await api.specialNeeds.get();
    return specialNeeds;
  };

  async componentDidMount() {
    try {
      const specialNeeds = await this.fetchSpecialNeeds();

      this.setState({
        specialNeeds,
        isLoading: false,
      } as any);
    } catch (err) {
      popupErrorFromServer(err);
    }
  }

  render() {
    const { isLoading } = this.state;

    const animal = this.state.animal;
    const specialNeeds = this.state.specialNeeds as SpecialNeed[];
    return (
      <Container>
        <Box>
          <Conditional check={!isLoading} alt={<LoadingSpinner />}>
            <Conditional check={specialNeeds !== undefined} alt={<p>Unable to load. No response from server</p>}>
              <AnimalEditForm animal={animal} specialNeeds={specialNeeds} isNewAnimal={true} />
            </Conditional>
          </Conditional>
        </Box>
      </Container>
    );
  }
}

export default CreateAnimal;
